export default {"src":"/_next/static/media/docxIcon.517395ca.svg","height":18,"width":17,"blurWidth":0,"blurHeight":0};